import "../styles/css/Qiddiya.css"
import "../styles/css/bootstrap.min.css"
import "../styles/css/agency.min.css"
import { Tabs, Tab } from "react-bootstrap"

function QiddiyaTime() {
  return (
    <div className="QiddiyaTimelineBackGround">
      <div className="QiddiyaTimeline container col-lg-8 text-center mt-5 ">
        <h2 className="section-heading " style={{ color: "rgb(0, 48, 102)" }}>
          Qiddiya's first phase of development is advancing toward a Grand Opening in 2023
        </h2>

        <Tabs className="container text-center mt-2" defaultActiveKey="home">
          <Tab className="container" eventKey="home" title="Phase 1">
            <section className="page-section " id="about">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center ">
                    <h2 className="section-heading text-uppercase">Phase One</h2>
                    <h3 className="section-subheading text-muted">
                      Plan, design and construct infrastructure and anchor attractions while creating project identity
                      and awareness.
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-image">
                          <img
                            className="rounded-circle img-fluid center"
                            src="https://static.vecteezy.com/system/resources/previews/000/548/595/non_2x/announcement-line-black-icon-vector.jpg"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div>
                            <h4>2017</h4>
                            <h4 className="subheading subheadingDark">Qiddiya Announced</h4>
                          </div>
                        </div>
                      </li>
                      <li className="timeline-inverted">
                        <div className="timeline-image" style={{ backgroundColor: "rgb(153, 201, 255)" }}>
                          <img
                            className="rounded-circle img-fluid"
                            src="https://png.pngtree.com/png-vector/20190301/ourlarge/pngtree-vector-planning-icon-png-image_747134.jpg"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div>
                            <h4>2018</h4>
                            <h4 className="subheading subheadingDark">Design & Planning</h4>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-image" style={{ backgroundColor: "rgb(239, 241, 241)" }}>
                          <img
                            className="rounded-circle img-fluid"
                            src="https://cdn0.iconfinder.com/data/icons/human-resource-2-3/66/113-512.png"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div>
                            <h4>2019 - 2021</h4>
                            <h4 className="subheading subheadingDark">Construction & Strategic PartnerShip</h4>
                          </div>
                        </div>
                      </li>
                      <li className="timeline-inverted">
                        <div className="timeline-image" style={{ backgroundColor: "rgb(214, 219, 219)" }}>
                          <img
                            className="rounded-circle img-fluid"
                            src="https://static.thenounproject.com/png/3303439-200.png"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div>
                            <h4>2021-2023</h4>
                            <h4 className="subheading subheadingDark">Testing & Grand Opening</h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </Tab>

          <Tab className="container" eventKey="profile" title="Phase 2">
            <section className="page-section " id="about">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center mt-2">
                    <h2 className="section-heading text-uppercase">Phase Two</h2>
                    <h3 className="section-subheading text-muted">Expanding Offerings & Growing Capacity</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-image " style={{ backgroundColor: "lightyellow" }}>
                          <img
                            className="rounded-circle img-fluid"
                            src="https://cdn4.iconfinder.com/data/icons/dashboard-3/100/9-512.png"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div>
                            <h4>2024</h4>
                          </div>
                        </div>
                      </li>
                      <li className="timeline-inverted">
                        <div className="timeline-image">
                          <img
                            className="rounded-circle img-fluid"
                            src="https://cdn.shopify.com/s/files/1/0015/4664/9636/products/69769_f130516c-46e6-44cd-97e2-88e29480b212_512x.png?v=1587388674"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div className="timeline-heading">
                            <h4>2026</h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </Tab>
          <Tab className="container" eventKey="contact" title="Phase 3">
            <section className="page-section " id="about">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center mt-2">
                    <h2 className="section-heading text-uppercase">Phase Three</h2>
                    <h3 className="section-subheading text-muted">Expanding Offerings & Growing Capacity</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-image" style={{ backgroundColor: "rgb(198, 236, 198)" }}>
                          <img
                            className="rounded-circle img-fluid"
                            src="https://cdn4.iconfinder.com/data/icons/dashboard-3/100/9-512.png"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div className="timeline-heading">
                            <h4>2027</h4>
                          </div>
                        </div>
                      </li>
                      <li className="timeline-inverted">
                        <div className="timeline-image" style={{ backgroundColor: "rgb(25, 77, 25)" }}>
                          <img
                            className="rounded-circle img-fluid "
                            src="https://image.flaticon.com/icons/png/512/2110/2110475.png"
                            alt=""
                          />
                        </div>
                        <div className="timeline-panel">
                          <div className="timeline-heading">
                            <h4>2031</h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}

export default QiddiyaTime
